import gsap from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin( ScrollToPlugin )

export const scrollToTop = () => {
    gsap.to( window, { duration: 1, scrollTo: 0 } )
}

export const scrollToElement = ( element: string ) => {
    gsap.to( window, { duration: 1, scrollTo: element } )
}